import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { constants } from '../constants';
import { FooterService } from './footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  otherDocuments = []
  isLogin:boolean = false

  constructor(
    private footerService: FooterService,
    public LANG: CommonUtilitiesService
  ) { }

  ngOnInit() {
    this.isLogin = !!localStorage.getItem("userData")
    this.footerService.getOtherDocuments().subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.otherDocuments = dataInfo['obj'].filter(current=>{
          if(current.description != "Reglamento de Abonados"){
            return current;
          }
        }).map(obj => {
          let newObj: any = new Object();
          newObj.file = obj.documentLink;
          newObj.title = obj.description;
          return newObj;
        });
      } else {
        console.log("No se ha podido establecer la conexión con el servidor.");
      }
    }),
      (err) => {
        console.log("No se ha podido establecer la conexión con el servidor.");
      });
  }

  openRegulationPdf() {
    window.open(constants.URL_PDF_REGULATIONS_SERVICES);
  }

  openPdf(file) {
    window.open(file);
  }
}
